module.exports = __webpack_public_path__ + "1a1147dded39367d364d23349297e6b2.pdf";